"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Vos Outils d’Accueil"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <p className={"text-normal mb-8"}>
                    Les visiteurs de l’office de tourisme sont également les visiteurs des socio-pros. Leurs questions sont souvent similaires.
                    C’est pour cela que nous avons souhaité donner l’accès à notre centre de ressources à l’ensemble de nos partenaires !
                    <br/>   <br/>
                    Nous devons garantir l’assurance de diffuser à vos visiteurs une information fiable, précise et mise à jour ! Pour ce faire, il nous faut mettre en place une dynamique collective au service de la mise en marché des entreprises.
                    <br/>   <br/>
                    Besoin d’un renseignement rapide pour vos clients ? Pensez à nous contacter directement par mail ou téléphone avec une ligne dédiée pour les socio-pros.
                    <br/>   <br/>
                    Un Glossaire pour améliorer notre communication
                </p>
            </SectionPage>


            <SectionPage sectionType="lg">
                <div className={"grid grid-cols-1 md:grid-cols-3 gap-4"}>
                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] text-center"}
                                   link="/pdf-viewer/GLOSSAIRE-UNWTO-TOURISME.pdf"
                                   image={"/images/espace-pro/office-et-vous/centre-de-ressources/outils-accueil/glossaire.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>
                </div>
            </SectionPage>

        </div>
    );
}
